module.exports = __webpack_public_path__ + "static/media/view.b28ff41c.svg";